<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h5 {{item}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Brand consulting and management",
    "pageDesc":"We provide brand consulting that help brands achieve growth and book the desired perceptions in their target audience minds.",
    "mantra":"Brand consulting |services.",
    "sec1Items":{
      "1":"Build better relationships with your customers by creating an emotional bond between your mark and your target audience.",
      "2":"Revolutionizing your brand through technology that automates your processes and lets you build up impressions easier and faster.",
      "3":"Solve your market entry issues with localization that is based on the research and deep insights of the population.",
      "4":"Keep your brand strategy and plans aligned with your on ground operations and target audience needs."
    },
    "sec2":"How we can help?",
    "sec2Items":{
      "1":{
        "title":"Brand positioning",
        "desc":"Analyzing the current emotions created about your brand then setting a strategy to convert them into the desired outcomes. "
      },
      "2":{
        "title":"Brand architecture",
        "desc":"Rearranging your organization style to suit your brand vision and communicate with your operations as well."
      },
      "3":{
        "title":"Brand expansion",
        "desc":"Moving your brand into your categories could be risky sometimes. We help you ensure consistent positioning and less development costs."
      }
    },
    "cta":"Create viral <br> campaigns now."
  },
  "ar": {
    "pageTitle":"استشارات الهوية التجارية",
    "pageDesc":"نقدم استشارات  للعلامات التجارية لمساعدتها على تحقيق النمو وحجز الانطباع المطلوب في أذهان جمهورها المستهدف.",
    "mantra":"استشارات الهوية التجارية |لانطباعات لا تنسى.",
    "sec1Items":{
      "1":"قم ببناء علاقات قوية مع عملائك من خلال إنشاء روابط عاطفية قوية بين علامتك وجمهورك المستهدف.",
      "2":"اجعل علامتك التجارية أكثر تطورًا من خلال التكنولوجيا التي تعمل على أتمتة العمليات وتتيح لك الظهور  بشكل منظم وسهل أمام جمهورك.",
      "3":"يمكنك حل مشكلات دخول الأسواق من خلال إضفاء الطابع المحلى الذي يستند إلى الأبحاث والرؤى العميقة لسكان كل سوق.",
      "4":"حافظ على إستراتيجية وخطط علامتك التجارية الخاصة واجعلها تتماشى مع العمليات التي تتم على أرض الواقع واحتياجات الجمهور المستهدف."
    },
    "sec2":"كيف يمكننا المساعدة؟",
    "sec2Items":{
      "1":{
        "title":"مكانة العلامة التجارية",
        "desc":"نحلل المشاعر والعلاقات التي تم إنشاؤها حول علامتك التجارية ثم نضع استراتيجية لتحويل هذه المشاعر والعلاقات إلى النتائج المنشودة."
      },
      "2":{
        "title":"هيكلة العلامة التجارية",
        "desc":"نعمل على إعادة ترتيب أسلوب مؤسستك  ليتناسب مع رؤية علامتك التجارية وكذلك مع طريقة تواصلك مع جمهورك المستهدف."
      },
      "3":{
        "title":"توسع العلامة التجارية",
        "desc":"قد يكون نقل علامتك التجارية وتوسعها محفوفًا بالمخاطر في بعض الأحيان. نساعدك على ضمان تحديد الموقع المثالي لك لنضمن شكل ثابت وتكاليف تطوير أقل."
      }
    },
    "cta":"احصل على استشارات <br> لعلامتك التجارية. "
  }
}
</i18n>
